"use strict";
exports.differenceInBusinessDays = differenceInBusinessDays;
var _index = require("./addDays.js");
var _index2 = require("./differenceInCalendarDays.js");
var _index3 = require("./isSameDay.js");
var _index4 = require("./isValid.js");
var _index5 = require("./isWeekend.js");
var _index6 = require("./toDate.js");
function differenceInBusinessDays(dateLeft, dateRight) {
  const _dateLeft = (0, _index6.toDate)(dateLeft);
  let _dateRight = (0, _index6.toDate)(dateRight);
  if (!(0, _index4.isValid)(_dateLeft) || !(0, _index4.isValid)(_dateRight))
    return NaN;
  const calendarDifference = (0, _index2.differenceInCalendarDays)(
    _dateLeft,
    _dateRight
  );
  const sign = calendarDifference < 0 ? -1 : 1;
  const weeks = Math.trunc(calendarDifference / 7);
  let result = weeks * 5;
  _dateRight = (0, _index.addDays)(_dateRight, weeks * 7);
  while (!(0, _index3.isSameDay)(_dateLeft, _dateRight)) {
    result += (0, _index5.isWeekend)(_dateRight) ? 0 : sign;
    _dateRight = (0, _index.addDays)(_dateRight, sign);
  }
  return result === 0 ? 0 : result;
}
